import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	searchData: {
		jobs: [
			{
				id: "",
				siteId: "",
				name: "",
				description: "",
				socialBalanceId: "",
				functionalGroupId: "",
			},
		],
		catalogNodes: [
			{
				id_Catalogo: "",
				nome: "",
				descricao: "",
				ordem: 0,
				data_Inicio: "",
				data_Fim: "",
				id_Pai: null,
				estrutura: "",
				id_Subsite: "",
				codigo: "",
				imagem: "",
				parentCatalogNode: null,
				courseVersions: [],
				programs: [],
			},
		],
		regions: [
			{
				id: "",
				siteId: "",
				name: "",
				description: "",
				isDefaultRecord: true,
				code: "",
				subSiteId: "",
				nationalityId: "",
				zoneId: "",
				approvers: null,
			},
		],
		subSites: [
			{
				id: "",
				siteId: "",
				name: "",
				shortName: "",
				regionId: "",
				address: "",
				zipCode: "",
				city: "",
				telephone: "",
				description: "",
				code: "",
				isActive: true,
				email: null,
				subRegionId: null,
				approvalDate: "",
			},
		],
		modalities: [
			{
				id: "",
				Code: "",
				name: "",
			},
		],
		programTypes: [
			{
				id_Tipo: "",
				id_Site: "",
				nome: "",
				descricao: "",
				readonly: true,
				m_Utilizador: "",
				m_Data: "",
				online: null,
			},
		],
	},
	catalogData: [
		{
			id: "",
			trainingType: "",
			name: "",
			ratingEval: null,
			catalogNode: {
				id_Catalogo: "",
				nome: "",
			},
			subSite: {
				id: "",
				siteId: "",
				name: "",
				shortName: "",
				regionId: "",
				address: "",
				zipCode: "",
				city: "",
				telephone: "",
				description: "",
				code: "",
				isActive: true,
				email: null,
				subRegionId: null,
				approvalDate: "",
			},
		},
	],
};

const CoursesCatalogSlice = createSlice({
	name: "CoursesCatalog",
	initialState: initialState,
	reducers: {
		updateCatalogData(state, action) {
			console.log("update CoursesCatalog");
			console.log(action);

			state.catalogData = action.payload;
		},
		updateCatalogSearchData(state, action) {
			console.log("update CatalogSearchData");
			console.log(action);

			state.searchData = action.payload;
		},
	},
});

export const CoursesCatalogActions = CoursesCatalogSlice.actions;

export default CoursesCatalogSlice;
